import { isV2LayoutEnabled } from '../../helpers/featureFlags/isV2LayoutEnabled';
import { LayoutV2 } from '../LayoutV2/LayoutV2';
import LeftNavbar from '../LeftNavbar/ProviderLeftNavbar';
import ProviderHeader from '../ProviderFileUpload/ProviderHeader';

function ProviderLayout(props) {
  return (
    <>
      <ProviderHeader />
      <div className="provider content">
        <LeftNavbar />
        <div className="provider rightbar">
          <div className="rightbarcontent">{props.children}</div>
        </div>
      </div>
    </>
  );
}

const ProviderLayoutVersion = isV2LayoutEnabled() ? LayoutV2 : ProviderLayout;

export default ProviderLayoutVersion;
